import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
    
    body, html {
      font-family: 'Roboto', sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      height: 100%;
    }
`;

export default GlobalStyles;
